




























































import { overlayElement } from '@/utils';

const transitionDelay = 200;
const dialogSelector = '#guideContainer';
const pointSelector = '#guidePointer';

const moveElements = (
  context: IView,
  dialog: any,
  point: any,
) => {
  dialog && overlayElement(dialogSelector, dialog.selector);
  point && overlayElement(pointSelector, point);
  setTimeout(() => {
    context.showElements = true;
    const selector = dialog
      ? dialogSelector
      : point
        ? pointSelector
        : null;

    // smooth scroll to dialog or pointer
    const exists = selector && document.querySelector(selector);
    exists
      && exists.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
  }, transitionDelay);
};

export default {
  props: {
    step: [String, Number],
    steps: Array,
  },
  data: () => ({
    showElements: false,
  }),
  computed: {
    isStepReferenced() {
      return typeof this.step !== 'number';
    },
    realIndex() {
      // search for step by reference in step
      return this.isStepReferenced
        ? (this.steps.findIndex((step: any) => step.ref === this.step) || -1)
        : this.step;
    },
    currentStep() {
      return this.steps[this.realIndex];
    },
  },
  watch: {
    step() {
      if (this.realIndex < 0) {
        const dialog = document.querySelector('#guideContainer');
        const pointer = document.querySelector('#guidePointer');
        dialog && dialog.remove();
        pointer && pointer.remove();
        return;
      }

      this.showElements = false;

      // wait for next tick so that dialog and point can be rendered
      this.$nextTick(() => {
        const { onEnter, dialog, point } = this.currentStep;
        onEnter
          ? onEnter().then(() => moveElements(this, dialog, point))
          : moveElements(this, dialog, point);
      });
    },
  },
  methods: {
    transitionAway(callback: () => void) {
      this.showElements = false;
      // wait until transitions of showElements complete
      setTimeout(callback, transitionDelay);
    },
    end() {
      this.transitionAway(() => this.$emit('end'));
    },
    next() {
      this.transitionAway(() => this.$emit('next'));
    },
    go(step: number) {
      this.transitionAway(() => this.$emit('go', step));
    },
  },
} as IView;
